module.exports = __webpack_public_path__ + "static/media/slide-mobile (7).8169a002.jpg";